/**
 * Abrir o «Reportar um problema» de qualquer sítio, sem cada ecrã ter de montar o
 * seu diálogo: há um só, montado uma vez (ver `ReportProblemHost`), e quem quer
 * abri-lo — o botão do cabeçalho, o aviso de um erro — chama `openReportDialog`.
 */

export type ReportDialogOptions = {
  /** O que a pessoa viu. Sem isto é um relatório livre: a mensagem é obrigatória. */
  title?: string;
  message?: string;
  area?: string;
  context?: Record<string, unknown>;
};

type Listener = (options: ReportDialogOptions) => void;
const listeners = new Set<Listener>();

export const openReportDialog = (options: ReportDialogOptions = {}): void => {
  listeners.forEach((listener) => listener(options));
};

export const subscribeReportDialog = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
